import { NovaContextProvider } from "./NovaContextProvider";
import type { JSX } from "react";

export function wrapInNovaProvider(component: JSX.Element): JSX.Element {
    return <NovaContextProvider>{component}</NovaContextProvider>;
}
